// NGRX
import { createFeatureSelector, createSelector } from '@ngrx/store';
// CRUD
import { QueryResultsModel, HttpExtenstionsModel } from '../../_base/crud';
// State
import { each } from 'lodash-es';
import { LoginState } from '../_reducers/login-log.reducers';
import { Login } from '../_models/login-log.model';
export const selectLoginState = createFeatureSelector<LoginState>('logins');

export const selectLoginById = (loginId: number) =>
  createSelector(selectLoginState, (loginState) => loginState.entities[loginId]);

export const selectLoginPageLoading = createSelector(selectLoginState, (loginState) => {
  return loginState.listLoading;
});

export const selectLoginActionLoading = createSelector(
  selectLoginState,
  (loginState) => loginState.actionsloading,
);

export const selectLastCreatedLoginId = createSelector(
  selectLoginState,
  (loginState) => loginState.lastCreatedLoginId,
);

export const selectLoginPageLastQuery = createSelector(
  selectLoginState,
  (loginState) => loginState.lastQuery,
);

export const selectLoginInStore = createSelector(selectLoginState, (loginState) => {
  const items: Login[] = [];
  each(loginState.entities, (element) => {
    items.push(element);
  });
  const httpExtension = new HttpExtenstionsModel();
  const result: Login[] = httpExtension.sortArray(
    items,
    loginState.lastQuery.sortField,
    loginState.lastQuery.sortOrder,
  );
  return new QueryResultsModel(result, loginState.totalCount);
});

export const selectLoginShowInitWaitingMessage = createSelector(
  selectLoginState,
  (loginState) => loginState.showInitWaitingMessage,
);

export const selectHasLoginInStore = createSelector(selectLoginState, (queryResult) => {
  if (!queryResult.totalCount) {
    return false;
  }

  return true;
});
